import { render, staticRenderFns } from "./GalleryWrapper.vue?vue&type=template&id=4e1043b7&scoped=true"
import script from "./GalleryWrapper.vue?vue&type=script&lang=js"
export * from "./GalleryWrapper.vue?vue&type=script&lang=js"
import style0 from "./GalleryWrapper.vue?vue&type=style&index=0&id=4e1043b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1043b7",
  null
  
)

export default component.exports